import {useSelector} from 'react-redux'
import {Offer} from '@findhotel/sapi'

import {getIsAuthenticated} from '@vio/core/src/auth/modules/selectors'
import getIsBofhOffer from '@vio/core/src/offer/business/isBofhOffer'
import {Offer as OfferType} from '@vio/core/src/offer/types/offer'

import {RootState} from '../../type'
import {
  getFrozenBookingByHotelId,
  getFrozenBookingByItinerary,
  getIsDealFreezeEnabled,
  getIsUserEligibleForDealFreeze,
  getOfferEncounteredError
} from '../modules/selector'
import {isOfferEligibleForDealFreeze} from '../utils/OfferEligibility'

interface Props {
  offer: Offer | OfferType
  checkIn: string
  checkOut: string
  isOfferAppLocked?: boolean
  hotelId?: string
  isOfferSoldOut?: boolean
}

export const useShouldShowDealFreezeButton = ({
  offer,
  checkIn,
  checkOut,
  isOfferAppLocked = false,
  hotelId,
  isOfferSoldOut = false
}: Props) => {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const isDealFreezeEnabled = useSelector(getIsDealFreezeEnabled)
  const isUserEligibleForDealFreeze = useSelector(
    getIsUserEligibleForDealFreeze
  )
  const frozenHotel = useSelector((state: RootState) =>
    getFrozenBookingByHotelId(state, hotelId)
  )
  const isBofhOffer = getIsBofhOffer(offer as Offer)

  const frozenItinerary = useSelector((state: RootState) =>
    getFrozenBookingByItinerary(state, checkIn, checkOut, hotelId)
  )
  const offerEncounteredError = useSelector((state: RootState) =>
    getOfferEncounteredError(state, offer?.id)
  )
  if (isOfferSoldOut) return false
  if (isOfferAppLocked) return false

  if (offerEncounteredError) return false
  // Unauthenticated users should be able to see the button. When they authenticate, their eligibility will be checked via the backend API.
  const eligibilityStatus = !isAuthenticated || isUserEligibleForDealFreeze

  if (!isDealFreezeEnabled) return false

  /**
   *  For RSP: if there are frozen rooms with the same hotelId and the same dates,
   *  we refrain from showing the button entirely for that offer.
   */
  if (frozenItinerary) return false
  if (frozenHotel && isBofhOffer) return true

  return isOfferEligibleForDealFreeze(offer?.tags || []) && eligibilityStatus
}
